const runtimeConfig = typeof window !== 'undefined' ? window.__POSCRAFT_CONFIG__ || {} : {};

/** Path under `public/` (no leading slash). */
export const BRAND_LOGO_PATH = String(runtimeConfig.BRAND_LOGO || 'assets/header-logo-2.png').replace(/^\//, '');
export const BRAND_FAVICON_PATH = String(runtimeConfig.BRAND_FAVICON || 'assets/favicon-2.png').replace(/^\//, '');
export const BRAND_PRIMARY_COLOR = String(runtimeConfig.BRAND_PRIMARY_COLOR || '#F58220').trim();
export const BRAND_PRIMARY_COLOR_DARK = String(runtimeConfig.BRAND_PRIMARY_COLOR_DARK || '#D96E10').trim();

export function applyBrandingTheme() {
  const root = document.documentElement;
  if (BRAND_PRIMARY_COLOR) {
    root.style.setProperty('--yellow', BRAND_PRIMARY_COLOR);
    root.style.setProperty('--cart', BRAND_PRIMARY_COLOR);
  }
  if (BRAND_PRIMARY_COLOR_DARK) {
    root.style.setProperty('--brand-accent-dark', BRAND_PRIMARY_COLOR_DARK);
  }
}

export function brandAssetUrl(assetBase, assetPath) {
  const base = String(assetBase || '').replace(/\/$/, '');
  const path = String(assetPath || '').replace(/^\//, '');
  return base ? `${base}/${path}` : `/${path}`;
}

export function brandLogoUrl(assetBase = '') {
  return brandAssetUrl(assetBase, BRAND_LOGO_PATH);
}
